import { z } from 'zod';
import { c } from '../../contract';

export const authorFollowersRouter = c.router(
  {
    addAuthorFollower: {
      summary: 'Add an author follower',
      method: 'POST',
      path: '',
      body: z.object({
        authorId: z.string(),
      }),
      responses: {
        201: z.object({
          listId: z.number(),
        }),
        400: z.object({
          reason: z.string(),
        }),
      },
    },
    removeAuthorFollower: {
      summary: 'Remove an author follower',
      method: 'DELETE',
      path: '/delete-author-follower',
      body: z.object({
        authorId: z.string(),
      }),
      responses: {
        200: z.literal('Success'),
        500: z.literal('Internal Server Error'),
      },
    },
    sendPushesToFollowers: {
      summary: 'Send pushes to Author followers',
      method: 'POST',
      path: '/send-push-to-followers',
      body: z.object({
        authorId: z.string(),
        authorName: z.string(),
      }),
      responses: {
        201: z.literal('Success'),
        500: z.literal('Internal Server Error'),
      },
    },
    processAuthorsFollowersCron: {
      summary: 'Cron job to process authors followers in bulk',
      method: 'POST',
      path: '/process-authors-followers-cron',
      body: z
        .object({
          batchSize: z.number().min(1).max(10).default(5),
          chunkSize: z.number().min(100).max(2000).default(2000),
        })
        .optional(),
      responses: {
        201: z.object({
          processedAuthors: z.number(),
          totalFollowersAdded: z.number(),
          message: z.string(),
        }),
        500: z.object({
          error: z.string(),
        }),
      },
    },
    sendPushToPostOwner: {
      summary: 'Send pushes to post owner',
      method: 'POST',
      path: '/send-push-to-post-owner',
      body: z.object({
        authorId: z.string(),
        postId: z.number(),
        userId: z.string(),
      }),
      responses: {
        201: z.literal('Success'),
        500: z.literal('Internal Server Error'),
      },
    },
  },
  {
    pathPrefix: '/author-followers',
  },
);
